var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74039 7.0539H7.30657L9.67609 0.625H1.83185L0.5 11.104H3.14817L1.98255 18.6931C1.95024 18.904 2.06673 19.109 2.26308 19.1872C2.45975 19.2651 2.68309 19.1951 2.80148 19.0187L10.8197 7.05394L9.74039 7.0539ZM1.83185 9.70973L2.30378 9.96096L1.80169 9.94693L1.83185 9.70973Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74039 7.0539H7.30657L9.67609 0.625H1.83185L0.5 11.104H3.14817L1.98255 18.6931C1.95024 18.904 2.06673 19.109 2.26308 19.1872C2.45975 19.2651 2.68309 19.1951 2.80148 19.0187L10.8197 7.05394L9.74039 7.0539ZM1.83185 9.70973L2.30378 9.96096L1.80169 9.94693L1.83185 9.70973Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5515 17.1045L14.1663 18.8545",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3935 14.9774C13.3935 16.6218 12.0742 17.9549 10.4467 17.9549C8.8193 17.9549 7.5 16.6218 7.5 14.9774C7.5 13.333 8.8193 12 10.4467 12C12.0742 12 13.3935 13.333 13.3935 14.9774Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSearch);
export default __webpack_public_path__ + "static/media/quick-search.a00487d42fd3e3f913c274f3c2c300bc.svg";
export { ForwardRef as ReactComponent };